(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adlv-homepage-revamp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
      if (slider.dataset.ready === 'true') return;
      slider.dataset.ready = 'true';
      const track = slider.querySelector('[data-hero-track]');
      const slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));
      const previous = slider.querySelector('[data-hero-previous]');
      const next = slider.querySelector('[data-hero-next]');
      const dots = slider.querySelector('[data-hero-dots]');
      let current = 0;
      let timer;
      const show = (index) => {
        current = (index + slides.length) % slides.length;
        track.style.transform = `translateX(-${current * 100}%)`;
        dots.querySelectorAll('button').forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === current ? 'true' : 'false');
        });
      };
      const restart = () => {
        window.clearInterval(timer);
        if (slider.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => show(current + 1), Number(slider.dataset.interval) || 7000);
        }
      };
      slides.forEach((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'adlv-home__hero-dot';
        dot.setAttribute('aria-label', `${index + 1}`);
        dot.addEventListener('click', () => {
          show(index);
          restart();
        });
        dots.appendChild(dot);
      });
      previous.addEventListener('click', () => {
        show(current - 1);
        restart();
      });
      next.addEventListener('click', () => {
        show(current + 1);
        restart();
      });
      slider.addEventListener('mouseenter', () => window.clearInterval(timer));
      slider.addEventListener('mouseleave', restart);
      slider.addEventListener('focusin', () => window.clearInterval(timer));
      slider.addEventListener('focusout', restart);
      show(0);
      restart();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
